import * as React from 'react';

import Stack from '@mui/material/Stack';

import GroupingFilterDialog from './GroupingFilterDialog';
import CoursePreviewTable from './CoursePreviewTable';

import Typography from '@mui/material/Typography';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import {THEME_DE, THEME_EN, LAST_UPDATE} from './Data';

import Alerts from './Alerts';

import DisclaimerEn from './DisclaimerEn';
import DisclaimerDe from './DisclaimerDe';

const INSTRUCTORS_PARAM = "instructors"
const LEVELS_PARAM = "levels"
const CREDITS_PARAM = "credits"
const ATTRIBUTES_PARAM = "attributes"
const LANGUAGES_PARAM = "languages"
const SEMESTERS_PARAM = "semesters"
const DETAILS_PARAM = "details"
const SEARCH_PARAM = "search"
const GROUPING_PARAM = "grouping"
const STUDY_PROGRAMS_PARAM = "studyProgram"
const LANG_PARAM = "lang"

function getInitialValue(currentUrlParameters, parameter, defaultValue) {
	if (currentUrlParameters.get(parameter) !== null) {
		const parameterValue = decodeURIComponent(currentUrlParameters.get(parameter));
		if (parameterValue === "") {
			return defaultValue;
		} else if (Array.isArray(defaultValue)) {
			return decodeURIComponent(parameterValue).split(",");
		} else if (typeof defaultValue === 'boolean') {
			return parameterValue.toLowerCase() === "true"; 
		} else if (typeof defaultValue === 'string') {
			return parameterValue;
		}
	} else {
		return defaultValue;
//		return localStorage.getItem(parameter) !== null ? JSON.parse(localStorage.getItem(parameter)) : defaultValue;
	}
}
/*
function storeLocal(parameter, state) {
	localStorage.setItem(parameter, JSON.stringify(state));
}
*/
export default function PreviewTable() {
	// inspect passed GET parameters, could be used for initial filters
	const currentUrlParameters = new URLSearchParams(document.location.search);

	const [language, setLanguage] = React.useState(getInitialValue(currentUrlParameters, LANG_PARAM, THEME_DE));
	
	const theme = createTheme({
	  language: language,
	  selLanguage: setLanguage
	});

	// React states
	// ============


	// quick search field (String)
	const [search, setSearch] = React.useState(getInitialValue(currentUrlParameters, SEARCH_PARAM, ""));

	// grouping (array of Strings)
	const [grouping, setGroup] = React.useState(getInitialValue(currentUrlParameters, GROUPING_PARAM, []));

	// filters
	const [instructorFilter, setInstructorFilter] = React.useState(getInitialValue(currentUrlParameters, INSTRUCTORS_PARAM, []));
	const [levelFilter, setLevelFilter] = React.useState(getInitialValue(currentUrlParameters, LEVELS_PARAM, []));
	const [cpFilter, setCpFilter] = React.useState(getInitialValue(currentUrlParameters, CREDITS_PARAM, []));
	const [attributeFilter, setAttributeFilter] = React.useState(getInitialValue(currentUrlParameters, ATTRIBUTES_PARAM, []));
	const [languageFilter, setLanguageFilter] = React.useState(getInitialValue(currentUrlParameters, LANGUAGES_PARAM, []));
	const [semesterFilter, setSemesterFilter] = React.useState(getInitialValue(currentUrlParameters, SEMESTERS_PARAM, []));
	const [studyProgram, setStudyProgram] = React.useState(getInitialValue(currentUrlParameters, STUDY_PROGRAMS_PARAM, ""));
	const [showDetails, setShowDetails] = React.useState(getInitialValue(currentUrlParameters, DETAILS_PARAM, true));

	// state of showing/hiding the filter dialog
	const [filterDialogOpen, setFilterDialogOpen] = React.useState(false);
	
	function getConfigUrl() {
		const params = new URLSearchParams();
		params.set(LANG_PARAM, theme.language);
		params.set(GROUPING_PARAM, encodeURIComponent(grouping.join(",")));
		params.set(INSTRUCTORS_PARAM, encodeURIComponent(instructorFilter.join(",")));
		params.set(LEVELS_PARAM, encodeURIComponent(levelFilter.join(",")));
		params.set(CREDITS_PARAM, encodeURIComponent(cpFilter.join(",")));
		params.set(ATTRIBUTES_PARAM, encodeURIComponent(attributeFilter.join(",")));
		params.set(LANGUAGES_PARAM, encodeURIComponent(languageFilter.join(",")));
		params.set(SEMESTERS_PARAM, encodeURIComponent(semesterFilter.join(",")));
		params.set(STUDY_PROGRAMS_PARAM, encodeURIComponent(studyProgram));
		params.set(DETAILS_PARAM, encodeURIComponent(showDetails));
		params.set(SEARCH_PARAM, encodeURIComponent(search));
		
		return (window.location.href.indexOf("?") === -1 ? 
			window.location.href
			: window.location.href.substring(0, window.location.href.indexOf("?"))
		) + "?" + params.toString();
	}
/*
	storeLocal(LANG_PARAM, theme.language);
	storeLocal(INSTRUCTORS_PARAM, instructorFilter);
	storeLocal(LEVELS_PARAM, levelFilter);
	storeLocal(CREDITS_PARAM, cpFilter);
	storeLocal(ATTRIBUTES_PARAM, attributeFilter);
	storeLocal(LANGUAGES_PARAM, languageFilter);
	storeLocal(SEMESTERS_PARAM, semesterFilter);
	storeLocal(STUDY_PROGRAMS_PARAM, studyProgram);
	storeLocal(DETAILS_PARAM, showDetails);
	storeLocal(SEARCH_PARAM, search);

	*/
	// define GUI elements
	return (
		<React.Fragment>
			<ThemeProvider theme={theme}>
				<Alerts />
				<Stack spacing={2}>
					{theme.language === THEME_DE ? <DisclaimerDe /> :
					 theme.language === THEME_EN ? <DisclaimerEn /> :
					 <></>}
					<GroupingFilterDialog 
						groupingState = {[grouping, setGroup]}
						instructionFilterState={[instructorFilter, setInstructorFilter]}
						levelFilterState={[levelFilter, setLevelFilter]}
						cpFilterState={[cpFilter, setCpFilter]}
						attributeFilterState={[attributeFilter, setAttributeFilter]}
						languageFilterState={[languageFilter, setLanguageFilter]}
						semesterFilterState={[semesterFilter, setSemesterFilter]}
						filterDialogState={[filterDialogOpen, setFilterDialogOpen]}
						searchState={[search, setSearch]}
						showDetailsState={[showDetails, setShowDetails]}
						studyProgramState={[studyProgram, setStudyProgram]}
						getConfigUrl={getConfigUrl}
					/>
					<CoursePreviewTable search={search} grouping={grouping} instructorFilter={instructorFilter}
						levelFilter={levelFilter} cpFilter={cpFilter} attributeFilter={attributeFilter}
						languageFilter={languageFilter} semesterFilter={semesterFilter} 
						showDetails={showDetails} studyProgram={studyProgram}/>
				</Stack>
				<Typography variant="body2" align="right">
				Last updated: {LAST_UPDATE}
				</Typography>
			</ThemeProvider>
		</React.Fragment>
	);
}